import { LoadingButton } from "@mui/lab";
import { Alert, Box, Button, TextField, Typography } from "@mui/material";
import AutoCompleteListFormik from "components/AutoCompleteListFormik";
import CustomDialog from "components/CustomDialog";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDistributorThunk } from "store/reducers/accounts";
import { locationStockTransactionThunk, resetStat } from "store/reducers/inventory/stock/locationStockSlice";
import * as yup from "yup";

const ReturnLocationStock = ({ open, handleClose, stock }) => {
  const dispatch = useDispatch();
  const validation = yup.object({
    qty: yup.number().required().positive().min(1).max(stock.qty),
  });
  const formik = useFormik({
    initialValues: {
      qty: stock.qty,
      product_variant: stock.product_variant,
      in_or_out: "ret",
      location: stock.location,
      distributor: null,
    },
    validationSchema: validation,
    onSubmit: (data) => {
      const newData = { ...data, distributor: data?.distributor?.profile?.id };
      console.log(newData);
      dispatch(locationStockTransactionThunk({ stock, data: newData }));
    },
    enableReinitialize: true,
  });
  const state = useSelector(
    (state) => state.locationStock.locationStockTransactionStatus
  );

  const stockSetting = useSelector((state) => state.inventorySettings?.data);

  useEffect(() => {
    dispatch(getDistributorThunk());
  }, []);
  const distributors = useSelector((state) => state.accounts.distributors);
  const [distributor, setDistributor] = useState(null);
  useEffect(()=>{
    dispatch(resetStat())
  },[])
  

  return (
    <CustomDialog
      forceFullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Return stock"
    >
      <Box padding={2}>
        <Typography variant="h6" color="text.secondary">
          You are about to return the following product
        </Typography>
        <Typography variant="h5" color="text.secondary">
          {stock.name}
        </Typography>
        <form onSubmit={formik.handleSubmit} style={{ marginTop: 2 }}>
          <TextField
            fullWidth
            name="qty"
            value={formik.values.qty}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.qty)}
            helperText={formik.errors.qty}
            type="number"
            sx={{ marginBottom: 2 }}
          />
          {stockSetting?.stock_level !== "location" && (
            <AutoCompleteListFormik
              items={distributors}
              name="username"
              label="Filter distributer"
              setValue={setDistributor}
              formik={formik}
              value={distributor}
              formikName="distributor"
              required={true}
            />
          )}

          {state?.error === "get" && (
            <Alert sx={{ my: 1 }} severity="error">
              Error occurred , {state?.errorMessage}
            </Alert>
          )}

          {state?.success === "get" && (
            <Alert sx={{ my: 1 }} severity="success">
              Success
            </Alert>
          )}
          <LoadingButton
            sx={{ mt: 2 }}
            variant="outlined"
            type="submit"
            loading={state?.loading === "get"}
          >
            Submit
          </LoadingButton>
        </form>
      </Box>
    </CustomDialog>
  );
};

export default ReturnLocationStock;
